/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * CustomerDataControllerApi - axios parameter creator
 */
export const CustomerDataControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost: (tenant_1, CustomerDataChangeEmail_1, ...args_1) => __awaiter(this, [tenant_1, CustomerDataChangeEmail_1, ...args_1], void 0, function* (tenant, CustomerDataChangeEmail, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantChangeEmailPost', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/changeEmail`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataChangeEmail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch: (tenant_1, CustomerDataChangeDateOfBirth_1, ...args_1) => __awaiter(this, [tenant_1, CustomerDataChangeDateOfBirth_1, ...args_1], void 0, function* (tenant, CustomerDataChangeDateOfBirth, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantDateOfBirthPatch', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/dateOfBirth`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataChangeDateOfBirth, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is used to confirm the email address for the user for 2 actions: On user confirmation this API endpoint will update the email for the customer and send out confirmation mail. On user confirmation this API endpoint will confirm the email address for the user after registration. The action will be based on the action associated with the token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} emailToken Token issued by CDS or LMS to update customers email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch: (tenant_1, emailToken_1, ...args_1) => __awaiter(this, [tenant_1, emailToken_1, ...args_1], void 0, function* (tenant, emailToken, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantEmailEmailTokenPatch', 'tenant', tenant);
            // verify required parameter 'emailToken' is not null or undefined
            assertParamExists('customerV1TenantEmailEmailTokenPatch', 'emailToken', emailToken);
            const localVarPath = `/customer/v1/{tenant}/email/{emailToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"emailToken"}}`, encodeURIComponent(String(emailToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet: (tenant_1, customerNumber_1, ...args_1) => __awaiter(this, [tenant_1, customerNumber_1, ...args_1], void 0, function* (tenant, customerNumber, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantMailSchedulerCustomerNumberMarketingLockGet', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('customerV1TenantMailSchedulerCustomerNumberMarketingLockGet', 'customerNumber', customerNumber);
            const localVarPath = `/customer/v1/{tenant}/mail-scheduler/{customerNumber}/marketing-lock`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submits the code received by SMS
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {MfaPhoneCodeConfirmationRequestV1} [MfaPhoneCodeConfirmationRequestV1] Request to submit the code received by SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost: (tenant_1, customerNumber_1, MfaPhoneCodeConfirmationRequestV1_1, ...args_1) => __awaiter(this, [tenant_1, customerNumber_1, MfaPhoneCodeConfirmationRequestV1_1, ...args_1], void 0, function* (tenant, customerNumber, MfaPhoneCodeConfirmationRequestV1, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost', 'customerNumber', customerNumber);
            const localVarPath = `/customer/v1/{tenant}/mfa/{customerNumber}/phone-verification/confirmation`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MfaPhoneCodeConfirmationRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submits a phone number for 2-Factor authentication for the given customer. The operation can be retriggered, in case the SMS wasn\'t received. Currently only permitted from both App Clients.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {MfaPhoneVerificationRequestV1} [MfaPhoneVerificationRequestV1] Request to verify a phone number for the given customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost: (tenant_1, customerNumber_1, MfaPhoneVerificationRequestV1_1, ...args_1) => __awaiter(this, [tenant_1, customerNumber_1, MfaPhoneVerificationRequestV1_1, ...args_1], void 0, function* (tenant, customerNumber, MfaPhoneVerificationRequestV1, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost', 'customerNumber', customerNumber);
            const localVarPath = `/customer/v1/{tenant}/mfa/{customerNumber}/phone-verification/request`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(MfaPhoneVerificationRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantPreferredLanguageGet', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/preferredLanguage`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataPreferredLanguage} [CustomerDataPreferredLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch: (tenant_1, CustomerDataPreferredLanguage_1, ...args_1) => __awaiter(this, [tenant_1, CustomerDataPreferredLanguage_1, ...args_1], void 0, function* (tenant, CustomerDataPreferredLanguage, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('customerV1TenantPreferredLanguagePatch', 'tenant', tenant);
            const localVarPath = `/customer/v1/{tenant}/preferredLanguage`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerDataPreferredLanguage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CustomerDataControllerApi - functional programming interface
 */
export const CustomerDataControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerDataControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeEmail} [CustomerDataChangeEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantChangeEmailPost(tenant, CustomerDataChangeEmail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantChangeEmailPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataChangeDateOfBirth} [CustomerDataChangeDateOfBirth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantDateOfBirthPatch(tenant, CustomerDataChangeDateOfBirth, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantDateOfBirthPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint is used to confirm the email address for the user for 2 actions: On user confirmation this API endpoint will update the email for the customer and send out confirmation mail. On user confirmation this API endpoint will confirm the email address for the user after registration. The action will be based on the action associated with the token
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} emailToken Token issued by CDS or LMS to update customers email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantEmailEmailTokenPatch(tenant, emailToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantEmailEmailTokenPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(tenant, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(tenant, customerNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantMailSchedulerCustomerNumberMarketingLockGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Submits the code received by SMS
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {MfaPhoneCodeConfirmationRequestV1} [MfaPhoneCodeConfirmationRequestV1] Request to submit the code received by SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(tenant, customerNumber, MfaPhoneCodeConfirmationRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(tenant, customerNumber, MfaPhoneCodeConfirmationRequestV1, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Submits a phone number for 2-Factor authentication for the given customer. The operation can be retriggered, in case the SMS wasn\'t received. Currently only permitted from both App Clients.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {MfaPhoneVerificationRequestV1} [MfaPhoneVerificationRequestV1] Request to verify a phone number for the given customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(tenant, customerNumber, MfaPhoneVerificationRequestV1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(tenant, customerNumber, MfaPhoneVerificationRequestV1, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantPreferredLanguageGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantPreferredLanguageGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {CustomerDataPreferredLanguage} [CustomerDataPreferredLanguage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch(tenant, CustomerDataPreferredLanguage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerV1TenantPreferredLanguagePatch(tenant, CustomerDataPreferredLanguage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CustomerDataControllerApi.customerV1TenantPreferredLanguagePatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CustomerDataControllerApi - factory interface
 */
export const CustomerDataControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerDataControllerApiFp(configuration);
    return {
        /**
         * Initiate email change. Validates the email, password and sends link for verification .
         * @param {CustomerDataControllerApiCustomerV1TenantChangeEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantChangeEmailPost(requestParameters, options) {
            return localVarFp.customerV1TenantChangeEmailPost(requestParameters.tenant, requestParameters.CustomerDataChangeEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
         * @param {CustomerDataControllerApiCustomerV1TenantDateOfBirthPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantDateOfBirthPatch(requestParameters, options) {
            return localVarFp.customerV1TenantDateOfBirthPatch(requestParameters.tenant, requestParameters.CustomerDataChangeDateOfBirth, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to confirm the email address for the user for 2 actions: On user confirmation this API endpoint will update the email for the customer and send out confirmation mail. On user confirmation this API endpoint will confirm the email address for the user after registration. The action will be based on the action associated with the token
         * @param {CustomerDataControllerApiCustomerV1TenantEmailEmailTokenPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantEmailEmailTokenPatch(requestParameters, options) {
            return localVarFp.customerV1TenantEmailEmailTokenPatch(requestParameters.tenant, requestParameters.emailToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
         * @param {CustomerDataControllerApiCustomerV1TenantMailSchedulerCustomerNumberMarketingLockGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters, options) {
            return localVarFp.customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits the code received by SMS
         * @param {CustomerDataControllerApiCustomerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(requestParameters, options) {
            return localVarFp.customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(requestParameters.tenant, requestParameters.customerNumber, requestParameters.MfaPhoneCodeConfirmationRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits a phone number for 2-Factor authentication for the given customer. The operation can be retriggered, in case the SMS wasn\'t received. Currently only permitted from both App Clients.
         * @param {CustomerDataControllerApiCustomerV1TenantMfaCustomerNumberPhoneVerificationRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(requestParameters, options) {
            return localVarFp.customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(requestParameters.tenant, requestParameters.customerNumber, requestParameters.MfaPhoneVerificationRequestV1, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to fetch the user\'s preferred language
         * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguageGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguageGet(requestParameters, options) {
            return localVarFp.customerV1TenantPreferredLanguageGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows to change the user\'s preferred language
         * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguagePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerV1TenantPreferredLanguagePatch(requestParameters, options) {
            return localVarFp.customerV1TenantPreferredLanguagePatch(requestParameters.tenant, requestParameters.CustomerDataPreferredLanguage, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerDataControllerApi - object-oriented interface
 */
export class CustomerDataControllerApi extends BaseAPI {
    /**
     * Initiate email change. Validates the email, password and sends link for verification .
     * @param {CustomerDataControllerApiCustomerV1TenantChangeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantChangeEmailPost(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantChangeEmailPost(requestParameters.tenant, requestParameters.CustomerDataChangeEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to change the user\'s birthday for use in e.g. change birthday page in account area. User should be minimum 18 years old.
     * @param {CustomerDataControllerApiCustomerV1TenantDateOfBirthPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantDateOfBirthPatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantDateOfBirthPatch(requestParameters.tenant, requestParameters.CustomerDataChangeDateOfBirth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is used to confirm the email address for the user for 2 actions: On user confirmation this API endpoint will update the email for the customer and send out confirmation mail. On user confirmation this API endpoint will confirm the email address for the user after registration. The action will be based on the action associated with the token
     * @param {CustomerDataControllerApiCustomerV1TenantEmailEmailTokenPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantEmailEmailTokenPatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantEmailEmailTokenPatch(requestParameters.tenant, requestParameters.emailToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows the mail-scheduler to get marketingLockOverall property by customerNumber
     * @param {CustomerDataControllerApiCustomerV1TenantMailSchedulerCustomerNumberMarketingLockGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantMailSchedulerCustomerNumberMarketingLockGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submits the code received by SMS
     * @param {CustomerDataControllerApiCustomerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantMfaCustomerNumberPhoneVerificationConfirmationPost(requestParameters.tenant, requestParameters.customerNumber, requestParameters.MfaPhoneCodeConfirmationRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submits a phone number for 2-Factor authentication for the given customer. The operation can be retriggered, in case the SMS wasn\'t received. Currently only permitted from both App Clients.
     * @param {CustomerDataControllerApiCustomerV1TenantMfaCustomerNumberPhoneVerificationRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantMfaCustomerNumberPhoneVerificationRequestPost(requestParameters.tenant, requestParameters.customerNumber, requestParameters.MfaPhoneVerificationRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to fetch the user\'s preferred language
     * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantPreferredLanguageGet(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantPreferredLanguageGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint allows to change the user\'s preferred language
     * @param {CustomerDataControllerApiCustomerV1TenantPreferredLanguagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerV1TenantPreferredLanguagePatch(requestParameters, options) {
        return CustomerDataControllerApiFp(this.configuration).customerV1TenantPreferredLanguagePatch(requestParameters.tenant, requestParameters.CustomerDataPreferredLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}
